import { useQuery } from '@tanstack/react-query';

import { QuestionnairesApi } from 'api';
import { QUESTIONNAIRE_TEMPLATES_KEY } from '../consts';
import { useUser } from '../useUser';

export function useQuestionnaireTemplates(isClonable = true) {
  const questionnaireApi = new QuestionnairesApi();
  const { userBankId } = useUser();

  const { data: questionnaireTemplates, isLoading: isLoadingQuestionnaireTemplates } = useQuery({
    enabled: !!userBankId.length,
    queryKey: [QUESTIONNAIRE_TEMPLATES_KEY, userBankId, isClonable],
    queryFn: () => questionnaireApi.getQuestionnaireTemplates(userBankId, isClonable)
  });
  return { questionnaireTemplates, isLoadingQuestionnaireTemplates };
}
